import styled, { keyframes } from 'styled-components';
import { ColorMixin } from '../../../styles/global';

const slideInFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-200px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideInFromBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(+200px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideInFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-200px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideInFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(+200px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;

  @media screen and (min-width: 1025px) {
    margin: auto;
    justify-content: center;
    display: flex;
    flex-direction: row;
    margin: 0;
  }
`;

export const Profile = styled.img`
  width: 100%;
  mix-blend-mode: lighten;
  rotate: 3deg;
  filter: saturate(140%);
  position: relative;
  overflow: hidden;

  @media screen and (min-width: 1025px) {
    width: 600px;
    left: -20px;
    margin-top: 40px;
  }
`;

export const Infos = styled.div`
  color: ${ColorMixin.secondary};
  margin-top: 50px;

  .texts {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }

  h1 {
    filter: drop-shadow(5px 5px 3px ${ColorMixin.active2});
    animation: ${slideInFromRight} 1.2s ease-in-out forwards;
    animation-delay: 1s;
    opacity: 0;

    font-size: 42px;
    text-align: center;
  }

  h3 {
    font-weight: 400;
    animation: ${slideInFromTop} 1.2s ease-in-out forwards;
    animation-delay: 0s;
    opacity: 0;
    font-size: 24px;
    text-align: center;
  }

  h2 {
    font-weight: 500;
    margin-top: 14px;
    animation: ${slideInFromBottom} 1.2s ease-in-out forwards;
    animation-delay: 2s;
    opacity: 0;
    font-size: 30px;
    /* text-align: center; */
  }

  span {
    animation: ${slideInFromLeft} 1.2s ease-in-out forwards;
    animation-delay: 2s;
    opacity: 0;
    font-size: 12px;
  }

  @media screen and (min-width: 400px) {
    span {
      font-size: 20px;
    }
  }

  @media screen and (min-width: 1025px) {
    .texts {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 15px;
    }

    margin-top: 30vh;

    h1 {
      border-bottom: 1px solid gray;
      text-align: left;
      font-size: 84px;
      width: fit-content;
    }

    h3 {
      text-align: left;
      font-size: 30px;
    }

    h2 {
      text-align: left;
      font-size: 44px;
    }

    span {
      font-size: 30px;
      align-self: top;
    }
  }
`;
